<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <ion-grid>
        <ion-row>
          <ion-col size-md="6" offset-md="3">
            <div class="ion-text-center">
              <h1 class="ion-no-margin">Reset Your Password</h1>
              <div v-if="!code" class="ion-margin">
                <ion-text color="danger">
                  There was a problem validating this reset link and code.
                </ion-text>
                <br />
                <ion-button
                  fill="outline"
                  color="danger"
                  size="small"
                  class="ion-margin-start"
                  @click="handleWantsResetPassword()"
                >
                  Tap here to request a new password reset
                </ion-button>
              </div>
              <form v-else @submit.prevent="handleResetPassword()">
                <ion-list lines="full">
                  <input-box
                    :validator="$v.password"
                    :error-messages="{
                      required: 'Please choose a password.',
                      minLength: 'Your password must be at least 8 characters.'
                    }"
                    :required="true"
                    v-model="password"
                    type="password"
                  >
                    Create New Password
                  </input-box>
                </ion-list>
                <div class="ion-padding">
                  <submit-button :submitting="submitting">
                    Sign In
                  </submit-button>
                </div>
              </form>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import passwordValidation from "@/validators/PasswordValidation";
import submittable from "@/mixins/submittable";
import { mapActions } from "vuex";

export default {
  title: "Reset Password",

  mixins: [submittable],

  data: function() {
    return {
      password: "",
      code: ""
    };
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get("oobCode");
  },

  methods: {
    ...mapActions("auth", ["signIn"]),

    handleWantsResetPassword() {
      this.$router.push({ name: "Forgot Password" });
    },

    handleResetPassword() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$auth()
          .verifyPasswordResetCode(this.code)
          .then(email => {
            return this.$auth()
              .confirmPasswordReset(this.code, this.password)
              .then(() => {
                return this.signIn({
                  email,
                  password: this.password
                }).then(() => {
                  this.$router.push("/");
                });
              });
          })
          .catch(() => {
            this.code = "";
          });
      }
    }
  },

  validations: {
    password: passwordValidation
  }
};
</script>
